import { MainLayout } from '../layouts';
import router from './index';

const asyncRoutes = [
  {
    path: '/station',
    component: MainLayout,
    redirect: '/station/list',
    meta: {
      title: '站点管理',
      icon: 'shop',
      permissionKey: 'getStation',
    },
    children: [
      {
        path: '/station/list',
        name: 'station-list',
        meta: {
          title: '站点列表',
          desc: '站点列表,站点列表',
          icon: 'none',
          permissionKey: 'getStation',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/station/list.vue'),
      },
      {
        path: '/station/add',
        name: 'station-add',
        icon: 'none',
        title: '添加站点',
        meta: {
          icon: 'none',
          title: '添加站点',
          desc: '添加站点相关信息',
          permissionKey: 'createStation',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/station/addAndModify.vue'),
      },
      {
        path: '/station/modify/:id',
        name: 'station-modify',
        icon: 'none',
        invisible: true,
        title: '修改站点',
        meta: {
          icon: 'none',
          title: '修改站点',
          desc: '修改站点相关信息',
          permissionKey: 'modifyStation',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/station/addAndModify.vue'),
      },
      {
        path: '/station/check/:id',
        name: 'station-check',
        icon: 'none',
        invisible: true,
        title: '站点检测',
        meta: {
          icon: 'none',
          title: '站点检测',
          desc: '站点建立之前的检测',
          permissionKey: 'stationCheck',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/station/StationCheck.vue'),
      },
      // {
      //   path: '/station/logs',
      //   name: 'station-logs',
      //   meta: {
      //     icon: 'none',
      //     title: '站点状态管理',
      //     desc: '站点状态管理，注意总链接数和有效心跳包',
      //     permissionKey: 'getDtulog',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/station/stationLog.vue'),
      // },
      {
        path: '/station/map',
        name: 'station-map',
        meta: {
          icon: 'none',
          title: '站点分布地图',
          desc: '站点分布地图',
          permissionKey: 'stationMap',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/station/map.vue'),
      },
    ],
  },
  {
    path: '/cabinet',
    component: MainLayout,
    title: '格口管理',
    meta: {
      icon: 'appstore',
      title: '格口管理',
      desc: '站点列表,站点列表',
      permissionKey: 'cabinetList',
    },
    redirect: '/cabinet/list',
    children: [
      {
        path: '/cabinet/list',
        name: 'cabinet-list',
        meta: {
          icon: 'none',
          title: '格口列表',
          desc: '站点格子管理列表,批量添加格子之前要先选择站点和组别',
          permissionKey: 'cabinetList',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/list.vue'),
      },
      {
        path: '/cabinet/empty-box',
        name: 'empty-box',
        meta: {
          icon: 'none',
          title: '僵尸件管理',
          desc: '系统根据综合情况分析出的僵尸件',
          permissionKey: 'emptybox',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/emptyBox.vue'),
      },
      {
        path: '/cabinet/logs',
        name: 'cabinet-logs',
        meta: {
          icon: 'none',
          title: '开门日志',
          showHeader: true,
          permissionKey: 'cabinetlog',
          desc: '提供格子开门记录查询,可以通过格子选择器选择或者时间选择',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/cabinetlogs.vue'),
      },
    ],
  },
  {
    path: '/business',
    component: MainLayout,
    meta: {
      title: '业务管理',
      icon: 'control',
      permissionKey: 'package',
    },
    redirect: '/business/packageslist',
    children: [
      {
        path: '/business/packageslist',
        name: 'packageslist',
        meta: {
          icon: 'none',
          title: '投递列表(最近30天)',
          showHeader: true,
          desc: '投递列表,快递员投递的最近30天数据',
          permissionKey: 'package',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/business/packages.vue'),
      },
      {
        path: '/business/history-packageslist',
        name: 'historypackageslist',
        meta: {
          icon: 'none',
          title: '投递列表(历史数据)',
          showHeader: true,
          desc: '投递列表,快递员投递的除今天以外的数据',
          permissionKey: 'historypackage',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/business/historypackages.vue'),
      },
      // {
      //   path: '/business/expresslist',
      //   name: 'expresslist',
      //   meta: {
      //     icon: 'none',
      //     title: '寄件列表',
      //     desc: '',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/business/packages.vue'),
      // },
      {
        path: '/business/dialyreport',
        name: 'dialyreport',
        meta: {
          icon: 'none',
          title: '数据日报',
          permissionKey: 'companyDailyreport',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/business/dialyreport.vue'),
      },
    ],
  },
  {
    path: '/device',
    component: MainLayout,
    redirect: '/device/list',
    meta: {
      title: '设备管理',
      icon: 'control',
      permissionKey: 'devices',
    },
    children: [
      {
        path: '/device/list',
        name: 'devices',
        meta: {
          icon: 'none',
          title: '设备管理',
          permissionKey: 'getDevice',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/device/List.vue'),
      },
      {
        path: '/device/log',
        name: 'device-log',
        meta: {
          icon: 'none',
          title: '设备日志',
          permissionKey: 'getDeviceLog',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/device/log.vue'),
      },
    ],
  },
  {
    path: '/customer',
    component: MainLayout,
    redirect: '/customer/user',
    meta: {
      title: '客户管理',
      icon: 'user',
      permissionKey: 'getWexinUser',
    },
    children: [
      {
        path: '/customer/partner',
        name: 'customerpartner',
        meta: {
          icon: 'none',
          title: '快递员管理',
          permissionKey: 'partner',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/partner/list.vue'),
      },
      {
        path: '/custom/user',
        name: 'customuser',
        meta: {
          icon: 'none',
          title: '微信用户',
          permissionKey: 'getWexinUser',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/user/list.vue'),
      },
      {
        path: '/custom/station-user',
        name: 'stationUser',
        meta: {
          icon: 'none',
          title: '站点用户',
          permissionKey: 'getCustom',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/user/stationUser.vue'),
      },
      {
        path: '/custom/comfirm-user',
        name: 'comfirmUser',
        meta: {
          icon: 'none',
          title: '需确认的用户信息',
          permissionKey: 'comfirmUser',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/user/comfirmUser.vue'),
      },
      // {
      //   path: '/custom/sensitive',
      //   name: 'sensitive',
      //   meta: {
      //     icon: 'none',
      //     title: '黑名单管理',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/list.vue'),
      // },
      // {
      //   path: '/custom/certification',
      //   name: 'certification',
      //   meta: {
      //     icon: 'none',
      //     title: '实名审核',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/list.vue'),
      // },
    ],
  },
  {
    path: '/finance',
    component: MainLayout,
    redirect: '/business/partner-deduct',
    meta: {
      title: '资金管理',
      icon: 'wallet',
      permissionKey: 'partnerDeduct',
    },
    children: [
      {
        path: '/financial/partner-deduct',
        name: 'partnerDeduct',
        meta: {
          icon: 'none',
          title: '快递员资金明细',
          permissionKey: 'partnerDeduct',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/financial/partnerDeduct.vue'),
      },
      {
        path: '/financial/partner-recharge',
        name: 'partnerRecharge',
        meta: {
          icon: 'none',
          title: '快递员充值记录',
          permissionKey: 'partnerRechargeList',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/financial/partnerRecharge.vue'),
      },
      {
        path: '/financial/user-overtime-pay',
        name: 'userOvertimePay',
        meta: {
          icon: 'none',
          title: '用户超时收费',
          permissionKey: 'userOvertimePay',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/financial/overtimePay.vue'),
      },
      // {
      //   path: '/business/expresslist',
      //   name: 'expresslist',
      //   meta: {
      //     icon: 'none',
      //     title: '用户资金明细',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/cabinet/list.vue'),
      // },
    ],
  },
  {
    path: '/company',
    component: MainLayout,
    redirect: '/company/list',
    meta: {
      title: '公司管理',
      icon: 'bank',
      permissionKey: 'getCompany',
    },
    children: [
      {
        path: '/company/list',
        name: 'companylist',
        meta: {
          icon: 'none',
          title: '公司管理',
          desc: `公众号验证地址：https://${process.env.VUE_APP_plate === 'yb' ? 'cabinet-api.youbanghelper.com' : 'api.ggbang.net'}/common/mp-notify?id=公司id`,
          permissionKey: 'getCompany',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/list.vue'),
      },
      {
        path: '/company/add',
        name: 'companyadd',
        meta: {
          icon: 'none',
          title: '添加公司',
          desc: '配置公司相关参数',
          permissionKey: 'createCompany',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/addAndModify.vue'),
      },
      {
        path: '/company/mpmenu/:id',
        name: 'companmpmenu',
        invisible: true,
        meta: {
          icon: 'none',
          title: '公众号菜单配置',
          desc: '配置公众号菜单',
          permissionKey: 'mpMenu',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/mpMenu.vue'),
      },
      {
        path: '/company/modify/:id',
        name: 'companymodify',
        invisible: true,
        meta: {
          icon: 'none',
          title: '修改公司',
          type: 'modify',
          permissionKey: 'modifyCompany',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/addAndModify.vue'),
      },
      {
        path: '/company/recharge/:id',
        name: 'companyrecharge',
        invisible: true,
        meta: {
          icon: 'none',
          title: '公司充值',
          type: 'recharge',
          permissionKey: 'companyRecharge',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/recharge.vue'),
      },
      // {
      //   path: '/company/recharge',
      //   name: 'rechargeList',
      //   meta: {
      //     icon: 'none',
      //     title: '公司充值记录',
      //     type: 'recharge',
      //     permissionKey: 'companyrecharge',
      //   },
      //   component: () => import(/* webpackChunkName: "login" */ '../views/company/rechargeList.vue'),
      // },
      {
        path: '/company/daily-report',
        name: 'companydailyreport',
        meta: {
          icon: 'none',
          title: '公司日报',
          type: 'recharge',
          permissionKey: 'companydailyreport',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/companydialyreport.vue'),
      },
      {
        path: '/company/consume',
        name: 'consume',
        meta: {
          icon: 'none',
          title: '公司经营流水',
          type: 'consume',
          permissionKey: 'companyrecharge',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/consume.vue'),
      },
      {
        path: '/company/withdrawal',
        name: 'withdrawal',
        meta: {
          icon: 'none',
          title: '公司提现管理',
          type: 'withdrawal',
          permissionKey: 'companywithdrawal',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/companywithdrawal.vue'),
      },
    ],
  },
  {
    path: '/settings',
    component: MainLayout,
    redirect: '/settings/user',
    meta: {
      title: '设置',
      icon: 'setting',
      permissionKey: 'getAdminUserList',
    },
    children: [
      {
        path: '/settings/voice',
        name: 'settings-voice',
        meta: {
          icon: 'none',
          title: '音效资源',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/settings/voice.vue'),
      },
      {
        path: '/settings/user',
        name: 'settingsuser',
        meta: {
          icon: 'none',
          title: '用户管理',
          permissionKey: 'getAdminUserList',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/user/adminUser.vue'),
      },
      {
        path: '/settings/resource',
        name: 'settingsresource',
        meta: {
          icon: 'none',
          title: '资源管理',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/settings/resource.vue'),
      },
      {
        path: '/settings/role',
        name: 'settingsrole',
        meta: {
          icon: 'none',
          title: '角色管理',
          permissionKey: 'roleList',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/settings/role.vue'),
      },
    ],
  },
];
export default (isSuperAdmin = false, permissions) => {
  let resultRouter = [];
  if (isSuperAdmin) {
    resultRouter = asyncRoutes;
  } else if (permissions && permissions.length > 0) {
    asyncRoutes.forEach((currentValue) => {
      if (permissions.includes(currentValue.meta.permissionKey)) {
        if (currentValue.children && currentValue.children.length > 0) {
          currentValue.children = currentValue.children.filter((item) => permissions.includes(item.meta.permissionKey));
        }
        resultRouter.push(currentValue);
      }
    });
  }
  router.addRoutes(resultRouter);
  const constRouter = router.options.routes;
  router.options.routes = [...constRouter, ...resultRouter];
};
